import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IVehicleRecallsResponse } from "../models/VehicleRecall";
import { IVehicle } from "../models/Vehicle";

export default function useVehicleRecalls(vehicle: IVehicle | null | undefined) {
  const { get } = useApiHelper();

  const vehicleRecalls = useQuery({
    queryKey: [
      "vehicleRecalls",
      vehicle?.combinedMake,
      vehicle?.modelRangeDescription,
      vehicle?.dvlaYearOfManufacture,
    ],
    queryFn: async () => {
      if (!vehicle) return null;

      const params = new URLSearchParams();
      if (vehicle.combinedMake) params.append("make", vehicle.combinedMake);
      if (vehicle.modelRangeDescription) params.append("model", vehicle.modelRangeDescription);
      if (vehicle.dvlaYearOfManufacture) {
        params.append(
          "manufacturedDate",
          new Date(vehicle.dvlaYearOfManufacture, 0, 1).toISOString().split("T")[0]
        );
      }

      const queryString = params.toString();
      return await get<IVehicleRecallsResponse>(
        `/vehicleRecall/search${queryString ? `?${queryString}` : ""}`
      );
    },
    enabled: !!vehicle && !!vehicle.combinedMake && !!vehicle.modelRangeDescription,
    staleTime: 1000 * 60 * 60, // 1 hour
  });

  return {
    vehicleRecalls,
  };
}
